module.exports = __webpack_public_path__ + "static/media/btg_04.640e0db2.png";